module.exports = __webpack_public_path__ + "img/modalBg2.e60f0752.png";